var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12887 5.38033C3.33389 5.17531 3.6663 5.17531 3.87133 5.38033L7.0001 8.5091L10.1289 5.38033C10.3339 5.17531 10.6663 5.17531 10.8713 5.38033C11.0764 5.58536 11.0764 5.91777 10.8713 6.12279L7.37133 9.62279C7.1663 9.82782 6.83389 9.82782 6.62887 9.62279L3.12887 6.12279C2.92384 5.91777 2.92384 5.58536 3.12887 5.38033Z",
    fill: "#6A6A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.932087480e4a242fcdb247925f66932e.svg";
export { ForwardRef as ReactComponent };